export const tempConverter = (K) => {
  return Math.floor(((K - 273.15) * 9) / 5 + 32);
};
